import * as api from "./../../api/index";
import * as ActionTypes from "./../ActionTypes";

export const signup = (dataForm, history) => async (dispatch) => {
    dispatch({ type: ActionTypes.REQ_AUTH });

    try {
        const { data } = await api.signUp(dataForm);

        dispatch({
            type: ActionTypes.AUTH,
            payload: data
        });

        history.push("/");
    } catch (error) {
        dispatch({
            type: ActionTypes.AUTH_ERROR,
            payload: error.response.data.message
        });
    }
}

export const signin = (dataForm, history) => async (dispatch) => {
    dispatch({ type: ActionTypes.REQ_AUTH });

    try {
        const { data } = await api.signIn(dataForm);

        dispatch({
            type: ActionTypes.AUTH,
            payload: data
        });

        history.push("/");
    } catch (error) {
        dispatch({
            type: ActionTypes.AUTH_ERROR,
            payload: error.response.data.message
        });
    }
}

export const logout = (history) => {
    localStorage.removeItem("profile");
    history.push("/");
}

export const editUser = (id, updatedUser, hitory) => async (dispatch) => {
    dispatch({ type: ActionTypes.REQ_AUTH });

    try {
        await api.editUser(id, updatedUser);

        logout(hitory);
    } catch (error) {
        dispatch({
            type: ActionTypes.AUTH_ERROR,
            payload: error.response.data.message
        });
    }
}

export const delAccount = (id, history, oldPass) => async (dispatch) => {
    dispatch({ type: ActionTypes.REQ_AUTH });

    try {
        await api.delAccount(id, { oldPass: oldPass });

        logout(history);
    } catch (error) {
        dispatch({
            type: ActionTypes.AUTH_ERROR,
            payload: error.response.data.message
        });
    }
}